module.exports = __webpack_public_path__ + "static/media/video_maisacesso.22a8cb10.mp4";